import { renderToString } from "react-dom/server";
import {
  CSAT_RATING_VALUES,
  csatSurveyLinkForRating,
} from "./csat-survey-link";

const ARROW_UP_RIGHT_URL =
  "https://data.getredo.com/redo/arrow-up-right_e9dcf42fc4b6.png";

/** Drawn as text, not an image, so the rating still renders when a client blocks images. */
const STAR_GLYPH = "★";

export interface CsatSurveyProps {
  headerImage: string;
  messageContent: string;
  surveyLink: string;
}

export function csatSurveyEmail(props: CsatSurveyProps): string {
  return renderToString(<CsatSurvey {...props} />);
}

const CsatSurvey = ({
  headerImage,
  messageContent,
  surveyLink,
}: CsatSurveyProps) => {
  return (
    <table
      border={0}
      cellPadding="0"
      cellSpacing="0"
      style={{ maxWidth: "750px", fontFamily: "'Inter-Regular', Helvetica" }}
      width="100%"
    >
      <tbody>
        {headerImage && (
          <tr>
            <td>
              <div style={{ textAlign: "center" }}>
                <img
                  src={headerImage}
                  style={{
                    height: "120px",
                    width: "670px",
                    display: "inline",
                    objectFit: "cover",
                  }}
                />
              </div>
            </td>
          </tr>
        )}
        <tr>
          <td style={{ padding: "32px" }}>
            <div
              dangerouslySetInnerHTML={{
                __html: messageContent
                  .replaceAll("<img", '<img style="max-width:750px"')
                  .replaceAll("<p></p>", "<p> </p>"),
              }}
            />
          </td>
        </tr>
        <tr>
          <td style={{ textAlign: "center", paddingTop: "8px" }}>
            <p style={{ fontSize: "16px" }}>How would you rate your service?</p>
          </td>
        </tr>
        <tr>
          {/* design-allow: email HTML — mail clients need inline styles, not design-system components */}
          <td style={{ textAlign: "center" }}>
            {CSAT_RATING_VALUES.map((rating) => (
              <a
                href={csatSurveyLinkForRating(surveyLink, rating)}
                key={rating}
                rel="noreferrer"
                /* design-allow: email HTML — mail clients need inline styles */
                style={{
                  color: "#f5a623",
                  display: "inline-block",
                  fontSize: "40px",
                  lineHeight: "44px",
                  padding: "0 6px",
                  textDecoration: "none",
                }}
                target="_blank"
                title={`${rating} out of ${CSAT_RATING_VALUES.length}`}
              >
                {STAR_GLYPH}
              </a>
            ))}
          </td>
        </tr>
        <tr>
          <td style={{ textAlign: "center" }}>
            <a
              href={surveyLink}
              rel="noreferrer"
              style={{
                display: "inline-block",
                padding: "12px 20px",
                backgroundColor: "#ffffff",
                color: "#424242",
                textDecoration: "none",
                borderRadius: "5px",
                border: "1px solid #d6d6d6",
                marginTop: "8px",
              }}
              target="_blank"
            >
              Leave a review
              <img
                src={ARROW_UP_RIGHT_URL}
                style={{
                  width: "20px",
                  height: "20px",
                  verticalAlign: "middle",
                  paddingLeft: "4px",
                  marginBottom: "2px",
                  display: "inline-block",
                }}
              />
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
